<!--
    校区管理-员工管理-开通年服务
    功能：开通年服务
    说明：版本3.0需求
-->
<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      title="开通年服务"
      width="650px"
    >
      <div class="content">
        <div class="tip"><i class="el-icon-warning icon"/>说明：默认赠送5个作课上课账号数</div>
        <div
          class="item-row"><span class="title">年服务时间：</span>{{ dateVal }}</div>
        <div
          class="item-row"
          style="color: red;">备注：默认1年，从开通服务时间开始算</div>
        <div
          class="item-row"
          style="padding-top:20px"><span class="title">年服务优惠价：</span><span class="pice">￥99999</span></div>
      </div>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          :loading="loading"
          type="primary"
          @click="submitData()">确认去支付</el-button>
      </span>
    </el-dialog>
    <open-play
      v-if="isPay"
      :visible.sync="isPay"/>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import openPlay from './openPlay.vue';

export default {
  name: 'SetAnnualFee',
  components: { openPlay },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      dateVal: null,
      isPay: false,
    };
  },
  mounted() {
    const now = dayjs().format('YYYY-MM-DD');
    const MM = dayjs().format('MM-DD');
    const YY = dayjs().year();
    this.dateVal = `${now} ~ ${YY + 1}-${MM}`;
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },
    submitData() {
      this.isPay = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.content{
  padding: 0 10px;
}
.tip{
  height: 40px;
  line-height: 40px;
  background: #FFFBE6;
  border-radius: 4px;
  border: 1px solid #FFE58F;
  margin-bottom: 15px;
  padding: 0 30px;
  .icon{
    color: #FAAD14;
    font-size: 16px;
    margin-right: 10px;
  }
}
.item-row{
  padding-top: 15px;
}
.pice{
  font-size: 20px;
    color: red;
}
.dialog-footer{
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Staff/components/openService.vue